const PARAGRAPH_BREAK = /<br\s*\/?>\s*<br\s*\/?>/i

/**
 * Site metadata stores the footer copyright line and the longform disclosure
 * as a single HTML string separated by a double <br>. Split them so a footer
 * can render content (e.g. a phone number) between the two.
 */
export const splitCopyrightText = (html: string): { copyright: string; disclaimer: string } => {
  const parts = html.split(PARAGRAPH_BREAK)
  if (parts.length < 2) {
    return { copyright: html.trim(), disclaimer: `` }
  }
  return {
    copyright: parts[0].trim(),
    disclaimer: parts.slice(1).join(`<br><br>`).trim(),
  }
}

/** Disclosure text only, without the leading copyright line. */
export const stripLeadingCopyright = (html: string): string => {
  const { copyright, disclaimer } = splitCopyrightText(html)
  return disclaimer || copyright
}
